import type { Tutorial } from '../../shared/types.js';

export const addMcpServerTutorial: Tutorial = {
  name: 'add-mcp-server',
  title: 'Add an MCP server',
  description:
    'Open the Add MCP Server form, choose a transport, name the server, and see where to save it.',
  category: 'mcp-servers',
  docPages: ['concepts/plugins'],
  agenda: ['Open the add-server form', 'Pick a transport and name it', 'Save when ready'],
  steps: [
    {
      id: 'open-dialog',
      kind: 'action',
      trigger: 'click',
      title: 'Open the form',
      body: 'Click "Add MCP Server" to open the create form.',
      target: '[data-tutorial-id="mcp-add-server"]',
      placement: 'left',
      path: '/configure/connect/mcp/servers',
      // The dialog normally opens on the popular-servers catalog (when
      // MCP OAuth is enabled), which hides the tabs/name/submit anchors
      // the next steps target. This signal makes the dialog open
      // straight on the custom form the tour narrates. Stamped on this
      // step and the next so the dialog mounts inside the window where
      // one of them is active.
      htmlSignals: { 'data-tutorial-mcp-skip-catalog': '1' },
    },
    {
      id: 'transport',
      kind: 'info',
      title: 'Pick a transport',
      body: 'Choose Remote for a hosted server reached through Runloop\u2019s MCP Hub, or Local to run a command on the devbox or have the agent connect to a URL directly. The fields below adapt to your choice.',
      target: '[data-tutorial-id="mcp-create-tabs"]',
      placement: 'bottom',
      htmlSignals: { 'data-tutorial-mcp-skip-catalog': '1' },
    },
    {
      id: 'name',
      kind: 'info',
      title: 'Name the server',
      body: 'Give it a unique, recognizable name: this is how the server appears in the launch dialog when you attach it to an agent.',
      target: '[data-tutorial-id="mcp-create-name"]',
      placement: 'bottom',
    },
    {
      id: 'save',
      kind: 'info',
      title: 'Save when ready',
      body: 'Fill in the remaining fields for your transport, then click here to add the server. It becomes available to every agent in your organization.',
      target: '[data-tutorial-id="mcp-create-submit"]',
      placement: 'top',
    },
  ],
};
